<template>
    <div class="row mb-4">
        <div class="col-md-3 mb-4">
            <label class="form-label" for="is_iplicit">In Iplicit</label>
            <select class="form-select" id="is_iplicit" v-model="filters.is_iplicit">
                <option value="">All</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
            </select>
        </div>
        <div class="col-md-3 mb-4">
            <label class="form-label" for="type">Type</label>
            <select class="form-select" id="type" v-model="filters.type">
                <option value="">All</option>
                <option value="standard">Standard</option>
                <option value="deposit">Deposit</option>
            </select>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search invoice number or booking reference...">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <th v-if="props.hideCentre === false">Centre</th>
            <th v-if="props.hideOrganisation === false">Organisation</th>
            <th v-if="props.hideCustomer === false">Customer</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="invoice_date">Invoice Date</sortableTh>
            <th>Type</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="cinolla_booking_reference">Booking Reference</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="cinolla_invoice_number">Invoice Number</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="total_gross">Total Gross</sortableTh>
            <th>Iplicit Status</th>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="invoice in data" :key="invoice.id">
                <td v-if="props.hideCentre === false">{{ invoice.centre_name }}</td>
                <td v-if="props.hideOrganisation === false">{{ invoice.organisation_name }}</td>
                <td v-if="props.hideCustomer === false">{{ invoice.customer_name }}</td>
                <td>{{ invoice.invoice_date }}</td>
                <td>{{ invoice.cinolla_invoice_type }}</td>
                <td>{{ invoice.cinolla_booking_reference }}</td>
                <td>{{ invoice.cinolla_invoice_number }}</td>
                <td>{{ invoice.total_gross }}</td>
                <td>{{ invoice.iplicit_invoice_status }}</td>
                <td v-html="invoice.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { onMounted, reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
    hideCentre: Boolean,
    hideCustomer: Boolean,
    hideOrganisation: Boolean,
});

const orderBy = ref('invoice_date');
const orderAsc = ref(false);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    is_iplicit: '',
    type: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};

onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const search = urlParams.get('search');

    if (search !== null) {
        searchTerm.value = search;
    }
});
</script>
